import { render, staticRenderFns } from "./DashboardRecentContents.vue?vue&type=template&id=a6d3cc16&scoped=true"
import script from "./DashboardRecentContents.vue?vue&type=script&lang=js"
export * from "./DashboardRecentContents.vue?vue&type=script&lang=js"
import style0 from "./DashboardRecentContents.vue?vue&type=style&index=0&id=a6d3cc16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d3cc16",
  null
  
)

export default component.exports